import { TextInput } from 'react-admin';
import ArrayForm from './ArrayForm';
import BoundedInput from './BoundedInput';

const ArraySharingCaption = ({ index, source, }: { source: string, index: number }) => {
  return (
    <>
      <ArrayForm source={`${source}.caption_0`} grid={0} simpleFormIteratorProps={{
        sx: {
          '& .RaSimpleFormIterator-form': {
            display: 'grid',
            gap: '0px',
            columnGap: '10px',
            gridTemplateAreas: `'title_en title_en title_tc title_tc title_sc title_sc'`
          }
        }
      }}>
        <BoundedInput source={`title_en`} input={<TextInput source="dummy" />} />
        <BoundedInput source={`title_tc`} input={<TextInput source="dummy" />} />
        <BoundedInput source={`title_sc`} input={<TextInput source="dummy" />} />
      </ArrayForm>
      <ArrayForm source={`${source}.caption_1`} grid={0} simpleFormIteratorProps={{
        sx: {
          '& .RaSimpleFormIterator-form': {
            display: 'grid',
            gap: '0px',
            columnGap: '10px',
            gridTemplateAreas: `'title_en title_en title_tc title_tc title_sc title_sc'`
          }
        }
      }}>
        <BoundedInput source={`title_en`} input={<TextInput source="dummy" />} />
        <BoundedInput source={`title_tc`} input={<TextInput source="dummy" />} />
        <BoundedInput source={`title_sc`} input={<TextInput source="dummy" />} />
      </ArrayForm>
    </>
  )
}

export default ArraySharingCaption;